import React, { Component, Fragment } from "react";
import "./style.scss";
import Table from "../../../components/table";
import { connect } from "react-redux";
import { getNotices, convertAdminNews, deleteNewsAdmin, ACTIONS } from './../../../actions/admin-news';
import queryString from 'query-string';
import Loading from './../../../components/loading/index';
class AdminNews extends Component {

    constructor(props) {
        super(props);
        this.state = {
            listNews: [],
            showLoading: true,
            idNews: '',
            pageSize: null,
            meta: null
        }
    }

    UNSAFE_componentWillMount() {
        const { history } = this.props;
        const values = queryString.parse(this.props.location.search);
        const pathname = this.props.location.pathname;
        if (!pathname.includes('add') && !pathname.includes('edit')) {
            const keyword = values.keyword || '';
            const page = values.page || 1;
            history.push(`?sort=email&order=asc&keyword=${keyword}&page=${page}`);
            this.props.getNotices(page, keyword);
            this.setState({
                showLoading: true
            })
        }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps && nextProps.response) {
            if (nextProps.type === ACTIONS.GET_DATA_ADMIN_NEWS_SUCCESS) {
                this.setState({
                    listNews: convertAdminNews(nextProps.response),
                    meta: nextProps.meta
                });
                this.setState({
                    showLoading: false
                })
            }
            if (nextProps.type === ACTIONS.DELETE_NEWS_SUCCESS) {
                this.getData();
            }
        }
    }

    navigateAddNew = () => {
        this.props.history.push('/admin-news/add')
    }

    actionItemDropdownDot = (event, key, item) => {
        key === 0 ? this.navigateEditNew(item) : this.deleteNew(item)
    }

    navigateEditNew = (item) => {
        this.props.history.push(`/admin-news/edit?id=${item[0].id}`)
    }

    deleteNew = (item) => {
        const wrapNewsDelete = document.getElementById('wrap-news-delete');
        wrapNewsDelete.style.display = 'flex';
        this.setState({
            idNews: item[0].id
        });
    }

    hideDeleteNews = (i) => {
        const wrapNewsDelete = document.getElementById('wrap-news-delete');
        wrapNewsDelete.style.display = 'none';
        if (i) {
            this.props.deleteNewsAdmin(this.state.idNews);
        }
    }

    componentDidMount = () => {
        this.commonHideComponent('wrap-news-delete', 'news-delete');
    }

    onChangePage = (page,check) => {
        const values = queryString.parse(this.props.location.search);
        if(Number(values.page||1)===Number(page||1)||!check){
            return;
        }
        let search;
        if (values.keyword) {
            search = `?keyword=${values.keyword}&page=${page}`
        } else {
            search = `?page=${page}`
        }
        this.props.history.push({
            pathname: '/admin-news',
            search: search
        })

        this.getData();
    }

    getData(){
        let self=this;
        setTimeout(() => {
            self.UNSAFE_componentWillMount();
        });
    }

    commonHideComponent = (p, c) => {
        const wrapWorkspace = document.getElementById(p);
        const workspace = document.getElementById(c);
        wrapWorkspace.addEventListener('click', function (event) {
            const isClickInside = workspace.contains(event.target);
            if (!isClickInside) {
                wrapWorkspace.style.display = 'none';
            }
        });
    }

    searchNews = (e) => {
        if (e.key === 'Enter') {
            this.setState({
                showLoading: true
            })
            this.props.history.push({
                pathname: '/admin-news',
                search:e.target.value?`?keyword=${e.target.value}`:""
            })
            this.getData();
        }
    }

    render() {
        return (
            <Fragment>
                <div className="admin-news">
                    <div className="block-title">
                        <h2 className="block-title__text--main">お知らせ配信</h2>
                        <div className="block-title__control">
                            <input type="text" className="searchbox" placeholder="検索" onKeyDown={(e) => this.searchNews(e)} />
                            <button type="button" className="button" onClick={this.navigateAddNew} >新規作成</button>
                        </div>
                    </div>

                    <div className="block-content">
                        <div className="wrapper">
                            <Table pageSize={this.state.pageSize} showPagination={true} actionItemDropdownDot={this.actionItemDropdownDot}
                                showPaginationTop={true} header={this.props.header} showCheckbox={false}
                                showSearch={false} itemOfPage={this.state.listNews} meta={this.state.meta}
                                onChangePage={this.onChangePage}

                            />
                        </div>
                    </div>
                </div>

                {/* delete news  */}
                <div className="wrap-news-delete" id="wrap-news-delete">
                    <div className="news-delete" id="news-delete">
                        <h4>お知らせの削除</h4>
                        <p>このお知らせを削除します。本当によろしいですか？</p>
                        <div>
                            <button onClick={() => this.hideDeleteNews(0)}>キャンセル</button>
                            <button onClick={() => this.hideDeleteNews(1)}>削除</button>
                        </div>
                    </div>
                </div>
                <Loading show={this.state.showLoading} />
            </Fragment>
        )
    }
}

const mapStateToProps = ({ adminNews }) => {
    return {
        header: adminNews.header,
        dataAdminNews: adminNews.dataAdminNews,
        response: adminNews.response,
        type: adminNews.type,
        status: adminNews.status,
        meta: adminNews.meta
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getNotices: (page, keyword) => {
            dispatch(getNotices(page, keyword));
        },
        deleteNewsAdmin: (id) => {
            dispatch(deleteNewsAdmin(id));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(AdminNews);